import { Form } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import { UseOrderItemPayload, useOrderItemForm } from '@hooks/useOrderItem'

import type { OrderItemModel } from '@models/types'

interface NotesProps {
 orderItem: OrderItemModel,
 callbacks: {
  updateOrderItemFn: UseOrderItemPayload['callbacks']['updateOrderItem'],
 },
}

const Notes = (props: NotesProps) => {
  const { callbacks, orderItem: initOrderItem } = props
  const { updateOrderItemFn } = callbacks

  const orderItemFormPayload = useOrderItemForm(initOrderItem)
  const {
    entityState: {
      additional_instructions,
    },
    setEntityState,
  } = orderItemFormPayload

  const updateOrderItemPayload = {
    callbacks: {
      action: updateOrderItemFn,
    },
    entityParams: { additional_instructions },
    toastText: 'Order Item Instructions Updated',
  }

  return (
    <Form.Field direction="column" label="Additional Instructions" marginTop="large">
      <textarea
        value={additional_instructions}
        placeholder="You can include additional instructions for the order..."
        onChange={e => setEntityState({ additional_instructions: e.target.value })}
        onBlur={() => handleCallbackAction(updateOrderItemPayload)}
        style={{ height: 80, resize: 'vertical' }}
      />
    </Form.Field>
  )
}

export default Notes
